import { Inject, Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { AlertifyService } from '@liebherr/old-sage-ui';
import { map, switchMap, tap } from 'rxjs/operators';
import { IamAPI } from '../api/core';
import { APP_CONFIG, AppConfig, AppState } from '../app.models';
import * as fromRouter from '../router';
import { finalizeEffect } from '../shared/operators/finalize-effect';
import * as fromTenants from '../tenants';
import * as fromUsers from '../users';
import { collectRoles, getLoggedInUserData } from '../utils';
import { USER_LANG_KEY } from './user.utils';
import * as UserActions from './users.actions';

@Injectable()
export class UserEffects {
    routerState$ = this.store.select(fromRouter.selectRouterState);
    loggedInuser$ = this.store.select(fromUsers.selectLoggedInUser);

    loadLoggedInUser$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(UserActions.loadLoggedInUser),
            tap(() => this.store.dispatch(UserActions.loading())),
            switchMap((action) => {
                return this.api.getProfile().pipe(
                    map((res) => {
                        if (res?.tenantId) {
                            this.store.dispatch(fromTenants.loadTenantDetails({ keycloakId: res.tenantId }));
                        }
                        return UserActions.loadedLoggedInUser({
                            data: {
                                ...res,
                                roles: collectRoles(getLoggedInUserData(), this.appConfig.oidc_clientId),
                            },
                        });
                    }),
                    finalizeEffect(() => this.store.dispatch(UserActions.loadingDone()))
                );
            })
        );
    });

    updateUserLang$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(UserActions.updateUserLanguage),
            map((action) => {
                if (action.user.languageCode) {
                    localStorage.setItem(USER_LANG_KEY, action.user.languageCode);
                }
                return UserActions.updatedLoggedInUser({ user: action.user });
            })
        );
    });

    constructor(
        private actions$: Actions,
        private store: Store<AppState>,
        private alertifyService: AlertifyService,
        private translateService: TranslocoService,
        private api: IamAPI,
        @Inject(APP_CONFIG) private appConfig: AppConfig
    ) {}
}
